import * as React from "react";
import Card from "../../../../cards/card/Card";
import {ImageObject} from "/src/components/image/Image";
import * as styles from "./slide-with-featured-cards.module.scss";

interface Props {
  cards: ReadonlyArray<Queries.FeaturedContentModuleCardFragmentFragment>;
}

export function SlideWithFeaturedCards(props: Props) {
  const {cards} = props;

  return (
    <div className={styles.slideWithFeaturedCards}>
      {cards.map((card, index) => {
        const {title, image, copy, ctaButtons, eyebrow, logo, ctaLink} = card;

        // we added support for multiple CTA at the very much later stage
        // so the following is to check, if ctaButtons is valid, then we pass along the value and ignore ctaLink value
        // otherwise, pass along ctaLink value
        const ctas = ctaButtons ? ctaButtons : ctaLink ? [ctaLink] : [];

        return (
          <Card
            key={index}
            copy={copy?.copy || undefined}
            ctas={ctas as Array<Queries.CtaButtonFragmentFragment>}
            eyebrow={eyebrow || undefined}
            headline={title || ""}
            image={(image as ImageObject) || undefined}
            logo={(logo as ImageObject) || undefined}
            useCardStyle
          />
        );
      })}
    </div>
  );
}
